// affirm
window.addEventListener("load", (event) => {
  setTimeout(() => {
    if (typeof affirm !== "undefined") {
      try{
        affirm.ui.ready(function () {
          var elAffirmContainer = document.querySelector(
            ".affirm-hidden-container .affirm-as-low-as"
          );
          var elAffirmTriggerDefault = document.querySelector(
            ".affirm-hidden-container .affirm-as-low-as .affirm-modal-trigger"
          );
          elAffirmTriggerDefault.innerText = '';

          var affirmHtml = elAffirmContainer.innerHTML.replace(
            `<a class="affirm-modal-trigger" aria-label="Learn more about Affirm Financing (opens in modal)" href="javascript:void(0)">Prequalify now</a>`,
            ""
          );
          var ringBuilder = document.querySelector("jd-ring-builder");
          ringBuilder._wrapper.$root.$el.__vue__.updateInstallments({
            html: affirmHtml,
          });
        });
      }catch(e){
        console.log(e);
      }
    }
  }, 2000); 
});
